import React from "react";

import { formatPrice, getCost } from "../../common";

import { ToolFields } from "types/admin/ToolFields";

import { Button } from "components/Button";

import { DataCellTools, Table, TableContainer, TableHead, TableTitle, TableToolbarTitle, TitleCount } from "../Table";

import { DataTableBody, DataTableCell, DataTableContent, DataTableRow } from "@rmwc/data-table";
import "@rmwc/data-table/styles";

import { Checkbox } from "@rmwc/checkbox";
import "@rmwc/checkbox/styles";

import Palette from "../../palette.json";
import { useProject } from "hooks/params/useProject";
import { useTask } from "hooks/params/useTask";
import { useHistory } from "react-router-dom";
import useTranslations from "hooks/useTranslations";

const totalStyle = {
  fontWeight: 500,
  fontSize: "16px",
};

export interface ToolListFields {
  tool: ToolFields;
  name: string;
  taskId: string;
}

interface ToolListProps {
  items: (ToolListFields | null)[];
  total?: number;
}

export const ToolList: React.FC<ToolListProps> = ({ items, total }) => {
  const { tCommon, tFeature } = useTranslations();
  const project = useProject();
  const history = useHistory();

  if (!project) return <></>;

  const cols: string[] = [
    tCommon("ToolNumber"),
    "Description",
    "Quantity",
    "Unit Price",
    "Lead Time",
    "Billable",
    "Cost",
  ];

  return (
    <TableContainer>
      <TableTitle>
        <TableToolbarTitle>
          {tCommon("Tools")} <TitleCount>({items.length})</TitleCount>
        </TableToolbarTitle>

        {/* <Button raised onClick={() => history.replace(`/work-orders/${project.id}/tasks/${task.id}/edit?tab=Tools`)}>
          Manage
        </Button> */}
      </TableTitle>

      <Table>
        <DataTableContent>
          <TableHead {...{ cols }} />

          <DataTableBody>
            {items.length === 0 && (
              <DataTableRow>
                <DataTableCell
                  colSpan={cols.length}
                  style={{ color: Palette.LightGrey, fontSize: "18px", textAlign: "center" }}
                >
                  - No Results -
                </DataTableCell>
              </DataTableRow>
            )}

            {items.map((it, i) => (
              <DataTableRow onClick={() => history.push(`/work-orders/${project.id}/tasks/${it?.taskId}`)} key={i}>
                {/* <DataTableCell>{it?.name}</DataTableCell> */}
                <DataTableCell>{it?.tool?.number}</DataTableCell>
                <DataTableCell>{it?.tool?.name}</DataTableCell>
                <DataTableCell>{it?.tool?.quantity}</DataTableCell>
                <DataTableCell>{formatPrice(it?.tool?.cost as number)}</DataTableCell>
                <DataTableCell>{it?.tool?.leadTimeDays}</DataTableCell>
                <DataTableCell>
                  <Checkbox disabled checked={it?.tool?.isBillable || false} />
                </DataTableCell>
                <DataTableCell>{it?.tool?.isBillable ? formatPrice(getCost(it.tool) as number) : "-"}</DataTableCell>
              </DataTableRow>
            ))}

            <DataTableRow>
              <DataTableCell style={totalStyle}>{tFeature("ToolList.totalLabel")}</DataTableCell>
              {[...Array(cols.length - 2).keys()].map((col, i) => (
                <DataTableCell key={i} />
              ))}
              <DataTableCell style={totalStyle}>{formatPrice(total || 0)}</DataTableCell>
            </DataTableRow>
          </DataTableBody>
        </DataTableContent>
      </Table>
    </TableContainer>
  );
};
